import { I18n } from '@lingui/core';
import { MetricField } from '@/__generated__/graphql';
import { t } from '@lingui/macro';

export const getMetricDisplayName = (metric: MetricField, i18n: I18n) => {
  // ── Hidráulica ──
  if (metric === MetricField.Flow) return t(i18n)`Caudal`;
  if (metric === MetricField.FlowRaw) return t(i18n)`Caudal (raw)`;
  if (metric === MetricField.DgaFlow) return t(i18n)`Caudal DGA`;
  if (metric === MetricField.Level) return t(i18n)`Nivel`;
  if (metric === MetricField.LevelRaw) return t(i18n)`Nivel (raw)`;
  if (metric === MetricField.DgaLevel) return t(i18n)`Nivel DGA`;
  if (metric === MetricField.Velocity) return t(i18n)`Velocidad`;
  if (metric === MetricField.DopplerVelocity) return t(i18n)`Velocidad Doppler`;
  if (metric === MetricField.Position) return t(i18n)`Posición`;
  if (metric === MetricField.Angle) return t(i18n)`Ángulo`;
  if (metric === MetricField.OriginalDistance) return t(i18n)`Distancia del sensor`;
  // ── Volúmenes ──
  if (metric === MetricField.AccumulatedVolume) return t(i18n)`Volumen acumulado`;
  if (metric === MetricField.DgaAccumulatedVolume) return t(i18n)`Volumen acumulado DGA`;
  if (metric === MetricField.VolumeDay) return t(i18n)`Volumen día`;
  if (metric === MetricField.VolumeHour) return t(i18n)`Volumen hora`;
  if (metric === MetricField.VolumeMonth) return t(i18n)`Volumen mes`;
  if (metric === MetricField.StoredVolume) return t(i18n)`Volumen almacenado`;
  // ── Calidad de agua ──
  if (metric === MetricField.Ph) return t(i18n)`pH`;
  if (metric === MetricField.Orp) return t(i18n)`ORP`;
  if (metric === MetricField.TurbidityFnu) return t(i18n)`Turbidez (FNU)`;
  if (metric === MetricField.TurbidityNtu) return t(i18n)`Turbidez (NTU)`;
  if (metric === MetricField.Temperature) return t(i18n)`Temperatura`;
  if (metric === MetricField.Conductivity) return t(i18n)`Conductividad`;
  if (metric === MetricField.DissolvedOxygen) return t(i18n)`Oxígeno disuelto`;
  if (metric === MetricField.DissolvedOxygenSaturation) return t(i18n)`Saturación O₂`;
  // ── Nieve ──
  if (metric === MetricField.SnowLevel) return t(i18n)`Nivel de nieve`;
  if (metric === MetricField.SnowWaterEquivalent) return t(i18n)`Equivalente agua nieve`;
  if (metric === MetricField.SnowTemperature) return t(i18n)`Temperatura nieve`;
  if (metric === MetricField.SnowWeight) return t(i18n)`Peso de nieve`;
  if (metric === MetricField.SnowRadiation) return t(i18n)`Radiación nieve`;
  // ── Energía / batería ──
  if (metric === MetricField.BatterySoc) return t(i18n)`Batería (%)`;
  if (metric === MetricField.BatteryV) return t(i18n)`Voltaje batería`;
  if (metric === MetricField.ChargeI) return t(i18n)`Corriente de carga`;
  if (metric === MetricField.ChargeP) return t(i18n)`Potencia de carga`;
  if (metric === MetricField.SolarP) return t(i18n)`Potencia solar`;
  if (metric === MetricField.SolarV) return t(i18n)`Voltaje solar`;
  if (metric === MetricField.SolarI) return t(i18n)`Corriente solar`;
  if (metric === MetricField.Energy) return t(i18n)`Energía`;
  // ── Señal ──
  if (metric === MetricField.SignalStrength) return t(i18n)`Señal`;
  if (metric === MetricField.SignalQuality) return t(i18n)`Calidad de señal`;
  if (metric === MetricField.SignalNoiseRatio) return t(i18n)`SNR`;

  return metric;
};
